module.exports = __webpack_public_path__ + "img/1.6ff7a5a3.webp";